import { render, staticRenderFns } from "./PendingTransfersGlobal.vue?vue&type=template&id=60688230&lang=pug"
import script from "./PendingTransfersGlobal.vue?vue&type=script&lang=js"
export * from "./PendingTransfersGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports